import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  subContractorRecords: [],
  totalPages: 0,
  currentPage: null,
};

export const SubContractorSlice = createSlice({
  name: "subContractor",
  initialState,
  reducers: {
    getSubContractorRecords: (state, action) => {
      state.subContractorRecords = action.payload.data;
      state.totalPages = action.payload.totalPages;
    },
  },
});

export const { getSubContractorRecords } = SubContractorSlice.actions;

export default SubContractorSlice.reducer;
